import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';

import { H5 } from '../../../AbstractElements';
import { Turnover } from '../../../Constant';
import { TurnOverChartData } from '../../../Data/Widgets/Chart/ChartData';

const TurnoverChart = () => {
  return (
    <>
      <Col xl='5' lg='12' className='xl-50'>
        <div className='small-chart-widget chart-widgets-small'>
          <Card>
            <CardHeader className='pb-0'>
              <H5>{Turnover}</H5>
            </CardHeader>
            <CardBody>
              <div className='chart-container'>
                <Row>
                  <Col xs='12'>
                    <div id='chart-widget7'>
                      <ReactApexChart options={TurnOverChartData.options} series={TurnOverChartData.series} height='320' type='area' />
                    </div>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
        </div>
      </Col>
    </>
  );
};
export default TurnoverChart;
